import axios from 'axios';
import { API_LINK } from '../values/constants';
import { toast } from 'react-toastify';
import LoadingService from './LoadingService';

const api = axios.create({
  baseURL: API_LINK,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const accessToken = sessionStorage.getItem("accessToken");
    const tempToken = sessionStorage.getItem("temp_token");

    const tokenToUse = accessToken || tempToken;

    if (tokenToUse) {
      config.headers.Authorization = `Bearer ${tokenToUse}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 1. Admin login
export const adminLogin = async (data: {
  username: string;
  password: string;
}) => {
  const payload = { ...data, type: 'admin-login' };
  const response = await api.post('auth/admin-login', payload);
  return response.data;
};


export const getSkuMaster = async () => {
  const response = await api.get('product/fetchSkuMaster');
  return response;
};

export const generateQr = async (data: {
  skuCode: string;
  quantity: number;
  purchaseOrderNumber: string;
}) => {
  const response = await api.post('qr/generateQr', data);
  return response;
};

export const getQrHistory = async () => {
  const response = await api.get('qr/fetchQrHistory');
  return response;
};

export const downloadQrFile = async (batchId: number) => {
  const response = await api.get(`qr/fetchQrFile?batchId=${batchId || ""}`);
  return response?.data;
};

export const getS3FileAsBuffer = async (url: string) => {
  const response = await axios.get(url, {
    responseType: "arraybuffer"
  });
  return Buffer.from(response.data);
};

export const getUserListForFilters = async () => {
  const response = await api.get('user/getUsersForFilter');
  return response?.data;
}

export const getRedemptionList = async (params: {
  mode?: string;
  userIds?: string;
  status?: string;
  fromDate?: string;
  toDate?: string;
}) => {
  const response = await api.get('redeem/listRedemptions', { params });
  return response?.data;
}

export const processRedemption = async (
  payload: { id: number; redemptionStatus: string; message: string }[]
) => {
  const response = await api.post("redeem/processRedemption", payload);
  return response?.data;
};

export const getKycList = async (params: {
  userId?: number;
  status?: string;
  documentType?: string;
  fromDate?: string;
  toDate?: string;
  limit?: number;
  skip?: number;
}) => {
  const response = await api.get('kyc/getDocumentList', { params });
  return response?.data;
};

export const getKycDocument = async (docId: number) => {
  const response = await api.get(`kyc/getDocumentUrl?docId=${docId}`);
  return response?.data;
};

export const updateKycDocumentStatus = async (params: { docId: number, message: string, status: string }) => {
  const response = await api.post(`kyc/updateKycDocumentStatus`, params);
  return response?.data;
};

export const getTicketList = async (params: {
  status?: string,
  category?: string,
  userId?: any,
  search: string,
}) => {
  const response = await api.get('tickets/tickets', { params });
  return response?.data;
};

export const getTicketListDocument = async (params: { id: number; }) => {
  const response = await api.get(`tickets/tickets/${params.id}/document`);
  return response?.data;
}

export const updateTicketStatus = async (id: number, body: any) => {
  const response = await api.patch(`tickets/tickets/${id}`, body);
  return response?.data;
}

export const addUser = async (params: {
  firstName?: string;
  lastName?: string;
  userEmail?: string;
  password?: string;
  userMobile?: string;
  userType?: string;
}) => {
  const response = await api.post('user/add-user', params);
  return response?.data;
};

export const getScanHistory = async (params?: {
  fromDate?: string;
  toDate?: string;
  scanStatus?: string;
  source?: string;
  skuCode?: string;
  userId?: string;
  serialNumber?: string;
}) => {
  const response = await api.get('scan/fetchScanHistoryAdminPanel', { params });
  return response?.data;
};

export const initiateBankTransfer = async (redemptionId: number) => {
  const response = await api.post('bank/initiate-payment', { redemptionId });
  return response?.data;
};

export const verifyPaymentStatus = async (paymentRefNo: string) => {
  const response = await api.post('bank/payment-inquiry', { PAYMENT_REF_NO: paymentRefNo });
  return response?.data;
};